<template>
  <div>
    <div slot="title">
      <h2>Historial de Estructura Orgánica</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="form-group col-3">
            <label for="tipoAreaId">Área</label>
            <C001Area
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Todas"                            
              v-on:valorParaElPadre="CambioArea"
              :valorDefinido="parametros_Area.areaId"
              :key="parametros_Area.areaId"
              :parametros="parametros_Area"
            ></C001Area>
          </div>
          <div class="form-group col-3">
            <label for="departamentoId">Departamento</label>
            <C039TiposDepartamento
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"                            
              v-on:valorParaElPadre="CambioTipoDepartamento"
              :valorDefinido="parametros_Departamento.departamentoId"              
              :hereda="this.parametros_Area.areaId"
              :key="this.parametros_Area.areaId"
            ></C039TiposDepartamento>
          </div>
          <div class="form-group col-3">
            <label for="tipoPuestoId">Puesto</label>
            <C045Puestos              
              :prefijo="enumeraciones.etiquetasDeHTML.Select"
              :tipo="enumeraciones.tiposDeSelect.Seleccione"              
              v-on:valorParaElPadre="CambioTipoPuesto"
              :valorDefinido="this.parametros_Puesto.puestoId"              
              :key="this.parametros_Departamento.departamentoId"
              :hereda="this.parametros_Departamento.departamentoId"
              :parametros="{
                AreaId: this.parametros_Area.areaId,
                DepartamentoId: this.parametros_Departamento.departamentoId
              }"
            ></C045Puestos>
          </div>
          <div class="form-group d-flex align-items-center col-3">            
            <button
              type="button"   
              v-on:click="BuscarHistoriaDeEstructuraOrganica()"           
              class="btn btn-primary"
            >
              Buscar
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="col-12 table-responsive">
            <table
              class="table  table-striped table-light table-hover"
              id="tabla_HistorialDeEstructuraOrganica"
              data-search="true"
              data-toggle="table"
              data-pagination="true"              
            >
              <thead class="thead-dark">
                <tr>
                  <th data-field="FechaInicial" data-sortable="true">
                    Fecha Inicial
                  </th>
                  <th data-field="FechaFinal" data-sortable="true">
                    Fecha Final
                  </th>
                  <th data-field="Persona.NumeroNomina" data-sortable="true">
                    # Nómina
                  </th>
                  <th data-field="Persona.Nombre" data-sortable="true">
                    Nombre
                  </th>
                  <th data-field="Persona.ApellidoPaterno" data-sortable="true">
                    Apellido Paterno
                  </th>
                  <th data-field="Persona.ApellidoMaterno" data-sortable="true">
                    Apellido Materno
                  </th>
                  <th data-field="TipoMovimiento.NombreMovimiento" data-sortable="true">
                    Movimiento
                  </th>
                  <th data-field="Puesto" data-sortable="true">
                    Puesto
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";

export default {
  data() {
    return {
      enumeraciones,
      historialLaboral: null,
      parametros_Area:{
        areaId:0
      },
      parametros_Departamento:{
        departamentoId: -1
      },
      parametros_Puesto:{
        puestoId: -1
      }  
    };
  },
  components: {
        C001Area : catalogos.PJ.C001Area,
        C039TiposDepartamento: catalogos.PJ.C039TipoDepartamento,
        C045Puestos: catalogos.PJ.C045Puestos
  },
  methods: {
    /*BecarioFormato: function operateFormatter(value, row, index) {
      return [
        '<a class="editar-becario" href="javascript:void(0)" title="Editar becario">',
        '<i class="fas fa-user-edit"></i>',
        "</a>"
      ].join("");
    },*/
    BuscarHistoriaDeEstructuraOrganica(){
      this.CargarHistorialDeEstructuraOrganica();
    },
    CambioArea(datos){
      this.parametros_Area.areaId = parseInt(datos.target.value);  
      this.parametros_Departamento.departamentoId = -1;
      this.parametros_Puesto.puestoId = -1;
    },
    CambioTipoDepartamento(datos){
        this.parametros_Departamento.departamentoId = parseInt(datos.target.value);   
        this.parametros_Puesto.puestoId = -1;         
    },
    CambioTipoPuesto(datos){
        this.parametros_Puesto.puestoId = parseInt(datos.target.value);    
    },
    CargarHistorialDeEstructuraOrganica() {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        AreaId: this.parametros_Area.areaId,
        DepartamentoId: this.parametros_Departamento.departamentoId,
        PuestoId: this.parametros_Puesto.puestoId
      };
      if(this.parametros_Area.areaId <= 0 || this.parametros_Departamento.departamentoId < 0 || this.parametros_Puesto.puestoId < 0)
      {
        comun.SeEstaCargandoInformacion(false);
        comun.mensajeDeAlerta("La combinación de filtros ingresada no es válida",null,null);
      }
      else{
        axios
          .post(
            api.conexion + api.SIAP.funcion.GetHistorialDeEstructuraOrganica,
            peticion,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal
            )
          )
          .then(response => {
            if (response.data.SiHayError == false) {
              console.log(response.data);
              this.historialLaboral = response.data.HistorialDeEstructuraOrganica;
              this.FormatearFechas();
              this.LlenarTablaHistorialDeEstructuraOrganica();
            } else {
              console.log(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch(e => {
            console.error(e);
            comun.mensajeDeAlerta(
              comun.mensajeDeError(enumeraciones.error.E500),
              null,
              null
            );
            comun.SeEstaCargandoInformacion(false);
          });
        }
    },
    FormatearFechas() {
      this.historialLaboral.forEach(item => {
        item.FechaFinal = this.obtenFechaConFormato(
          item.FechaFinal,
          "DD-MM-YYYY"
        );
        item.FechaInicial = this.obtenFechaConFormato(
          item.FechaInicial,
          "DD-MM-YYYY"
        );
      });
    },
    obtenFechaConFormato(fecha, formato) {
      formato =
        formato == null || formato == undefined ? "DD-MM-YYYY" : formato;
      return fecha ? moment(fecha).format(formato) : "";
    },
    LlenarTablaHistorialDeEstructuraOrganica() {
      var $tablaHistorialDeEstructuraOrganica = $(
        "#tabla_HistorialDeEstructuraOrganica"
      );
      $tablaHistorialDeEstructuraOrganica.bootstrapTable({
        data: this.historialLaboral
      });
      $tablaHistorialDeEstructuraOrganica.bootstrapTable(
        "load",
        this.historialLaboral
      );
    },
    ///Inicia los eventos que tendran los iconos de las acciones
    IniciarEventosDeLasAcciones() {
      // (e, value, row, index)
      window.operateEvents = {
        "click .editar-becario": (e, val, row, index) => {
          this.editarUsuario(row.CURP);
        }
      };
    },
    editarUsuario: function(curpUsuario) {
      //Redirigeal usuario a la pantalla de editarusuario mandando como parametro el id de persona a editar
      this.$router.push({
        name: "AltaDeUsuario",
        params: { propCurp: curpUsuario }
      });
    }
  },

  mounted: function() {  
    //this.IniciarEventosDeLasAcciones();
  }
};
</script>

<style scoped>
/* Se requiere para que el color del texto de la tabla sea negro */
table {
  color: #343a40 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SIAP/AdministracionPersonal/HistorialDeEstructuraOrganica.vue